import React, { useState, useEffect, useMemo } from 'react';
import { FaCalendarDay, FaClock, FaMotorcycle } from 'react-icons/fa';
import * as S from './styles';
import RModal from '../../../components/Rsuite/Modal';
import api from '../../../services/api';
import { CustomButton } from '../../../components/CustomButton';
import { CustomInput } from '../../../components/CustomInput';
import { CustomCheckPicker } from '../../../components/CustomCheckPicker';
import { CustomToggle } from '../../../components/CustomToggle';
import { InfoDescription } from '../../../components/InfoDescription';
import { toastSuccess, toastError, toastInfo } from '../../../toasts';
import { Checkbox } from 'rsuite';
import { diasDaSemana } from '../constants';

const EditarCadastrarHorario = ({
  modal,
  close,
  horario,
  diaFixo,
  setHorarios,
  id_empresa,
}) => {
  const [idDia, setIdDia] = useState('');
  const [diaSemana, setDiaSemana] = useState([]);
  const [horaI, setHoraI] = useState('');
  const [horaF, setHoraF] = useState('');
  const [ativo, setAtivo] = useState('');
  const [permiteEntrega, setPermiteEntrega] = useState(true);
  const [permiteRetirada, setPermiteRetirada] = useState(true);

  const allValue = useMemo(() => diasDaSemana.map(item => item.value), []);

  const abrirDados = (horario) => {
    let dia = diasDaSemana.find((dia) => dia.value.value === horario.DiaSemana);
    setIdDia(horario.Id);
    setDiaSemana(dia ? [dia.value] : []);
    setHoraI(horario.Inicio);
    setHoraF(horario.Fim);
    setAtivo(horario.Funciona);
    setPermiteEntrega(horario.PermiteEntrega);
    setPermiteRetirada(horario.PermiteRetirada);
  };

  const handleCheckAll = (_, checked) => {
    console.log({  checked, allValue });
    setDiaSemana(checked ? allValue : []);
  };

  const editarHorario = async () => {
    if (!diaSemana || diaSemana.length === 0 || !horaI || !horaF) {
      toastError('Preencha todos os campos obrigatórios');
      return;
    }

    if (!idDia) {
      await api
        .post('horario/criar', {
          IdEmpresa: id_empresa,
          DiaSemana: diaSemana,
          Inicio: horaI,
          Fim: horaF,
          PermiteEntrega: permiteEntrega,
          PermiteRetirada: permiteRetirada,
        })
        .then((res) => {
          toastSuccess('Horário cadastrado com sucesso!');
          setHorarios((state) => [...state, ...res.data]);
          close();
        })
        .catch((error) =>
          toastError(
            error?.response?.data?.message || 'Erro ao cadastrar horário',
          ),
        );
    } else {
      await api
        .patch(`horario/alterar/${idDia}`, {
          Inicio: horaI,
          Fim: horaF,
          Funciona: ativo,
          PermiteEntrega: permiteEntrega,
          PermiteRetirada: permiteRetirada,
        })
        .then((res) => {
          toastInfo('Horário alterado com sucesso!');
          setHorarios((state) =>
            state.map((e) => (e.Id !== res.data.Id ? e : res.data)),
          );
          close();
        })
        .catch((error) =>
          toastError(
            error?.response?.data?.message || 'Erro ao alterar horário',
          ),
        );
    }
  };

  useEffect(() => {
    if (horario) {
      abrirDados(horario);
    } else if (!horario && modal) {
      setIdDia('');
      setDiaSemana(diaFixo ? [diaFixo] : []);
      setHoraI('');
      setHoraF('');
      setAtivo('');
      setPermiteEntrega(true);
      setPermiteRetirada(true);
    }
  }, [modal, horario, diaFixo]);

  useEffect(() => {
    console.log({ diaSemana });
  }, [diaSemana]);

  return (
    <RModal
      open={modal}
      onClose={close}
      title={
        horario
          ? 'Editar Turno de Expediente'
          : diaFixo
          ? `Adicionar Horário - ${diaFixo.label}`
          : 'Cadastrar Novo Turno'
      }
      footer={
        <>
          <CustomButton onClick={editarHorario} appearance="primary">
            Salvar
          </CustomButton>
          <CustomButton onClick={close} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <S.FormContainer>
        <div>
          <S.SectionTitle>
            <FaCalendarDay /> Dia da Semana
          </S.SectionTitle>
          <S.FormGroup>
            {horario || diaFixo ? (
              <S.ReadOnlyText>
                {diaSemana[0]?.label || 'Dia Selecionado'}
              </S.ReadOnlyText>
            ) : (
              <>
                <S.Label>
                  Selecione o Dia <S.RequiredMark>*</S.RequiredMark>
                </S.Label>
                <CustomCheckPicker
                  placeholder="Ex: Segunda-feira, Terça-feira..."
                  searchable={false}
                  data={diasDaSemana}
                  value={diaSemana}
                  onChange={setDiaSemana}
                  style={{ width: '100%' }}
                  renderExtraFooter={() => (
                    <>
                      <Checkbox
                        indeterminate={diaSemana?.length > 0 && diaSemana?.length < allValue.length}
                        checked={diaSemana?.length === allValue.length}
                        onChange={handleCheckAll}
                      >
                        Selecionar Todos
                      </Checkbox>
                    </>
                  )}
                />
              </>
            )}
          </S.FormGroup>
        </div>
        <div>
          <S.SectionTitle>
            <FaClock /> Horário do Turno
          </S.SectionTitle>
          <S.FormRow>
            <S.FormGroup>
              <S.Label>
                Abertura <S.RequiredMark>*</S.RequiredMark>
              </S.Label>
              <CustomInput type="time" value={horaI} onChange={setHoraI} />
            </S.FormGroup>
            <S.FormGroup>
              <S.Label>
                Fechamento <S.RequiredMark>*</S.RequiredMark>
              </S.Label>
              <CustomInput type="time" value={horaF} onChange={setHoraF} />
            </S.FormGroup>
          </S.FormRow>
        </div>
        <div>
          <S.SectionTitle>
            <FaMotorcycle /> Serviços Habilitados
          </S.SectionTitle>
          <S.ServicesContainer>
            <S.ToggleRow>
              <InfoDescription
                label="Delivery (Entrega)"
                description="Os clientes poderão solicitar entregas em domicílio durante este horário."
              />
              <CustomToggle
                id="permiteEntrega"
                checked={permiteEntrega}
                onChange={() => setPermiteEntrega(!permiteEntrega)}
              />
            </S.ToggleRow>
            <S.ToggleRow>
              <InfoDescription
                label="Retirada no Local / Mesa"
                description="Habilita a opção do cliente buscar o pedido na loja ou consumir presencialmente."
              />
              <CustomToggle
                id="permiteRetirada"
                checked={permiteRetirada}
                onChange={() => setPermiteRetirada(!permiteRetirada)}
              />
            </S.ToggleRow>
          </S.ServicesContainer>
        </div>
      </S.FormContainer>
    </RModal>
  );
};

export default EditarCadastrarHorario;
